// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JWhJ","rootMobile":"styles_rootMobile__1f6Ji"};